import gql from "graphql-tag";

export const DELETE_CATEGORY = gql`
  mutation deleteCategory($categoryId: String!, $transferId: String!) {
    deleteCategory(categoryId: $categoryId, transferId: $transferId)
  }
`;
